document.addEventListener('DOMContentLoaded', function () {
  // Select all play buttons and video containers
  const videoContainers = document.querySelectorAll('.cc-multi-column-videos .video-section');

  // Add click event listener to each video container
  videoContainers.forEach((container) => {
    container.addEventListener('click', function (event) {
      // Find the video element and play button within the clicked container
      const video = container.querySelector('video');
      const playButton = container.querySelector('.card__video__play-icon');

      // Pause all other videos and show their play buttons
      const allVideos = document.querySelectorAll('.cc-multi-column-videos video');
      allVideos.forEach((v) => {
        if (v !== video) {
          v.pause();
          v.closest('.video-section').querySelector('.card__video__play-icon').classList.remove('hidden');
        }
      });

      // Play or pause the clicked video and toggle the play button visibility
      if (video) {
        if (video.paused) {
          video.play();
          playButton.classList.add('hidden');
        } else {
          video.pause();
          playButton.classList.remove('hidden');
        }
      }
    });
  });

  // IntersectionObserver to pause videos that go out of the viewport
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target.querySelector('video');
      const playButton = entry.target.querySelector('.card__video__play-icon');
      if (!entry.isIntersecting && video && !video.paused) {
        // Pause the video if it's out of view and show the play button
        video.pause();
        playButton.classList.remove('hidden');
      }
    });
  }, {
    threshold: 0.5 // Adjust this threshold as needed
  });

  // Observe each video container
  videoContainers.forEach(container => observer.observe(container));
});
